import React from "react";
import { RaisedButton, TextField } from "material-ui";

import connectToStores from "alt-utils/lib/connectToStores";
import VirtualContentStore from "../../stores/VirtualContentStore";
import VirtualContentActions from "../../actions/VirtualContentActions";

import VirtualContentUploader from "./virtual-content-uploader.jsx";
import VirtualContentPreviewOverlay from "./overlays/virtual-content-preview.jsx";
import OrderablePanel from "./orderable-panel.jsx";
import WorkingIndicator from "./working-indicator.jsx";
import LinkLike from "./link-like.jsx";
import { Status } from "./film-table.jsx";

class VirtualContentEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAdding: false,
      showPreviewForVirtualContent: false
    };

    this.remove = this.remove.bind(this);
    this.add = this.add.bind(this);
    this.shiftPosition = this.shiftPosition.bind(this);
  }

  static getStores() {
    return [VirtualContentStore];
  }

  static getPropsFromStores() {
    return VirtualContentStore.getState();
  }

  componentWillMount() {
    if (this.props.value && this.props.value.length) {
      VirtualContentActions.fetchByIds.defer(this.props.value);
    }
  }

  componentWillReceiveProps(newProps) {
    if (
      (!this.props.value && newProps.value) ||
      (newProps.value &&
        newProps.value.some(v => this.props.value.indexOf(v) === -1))
    ) {
      VirtualContentActions.fetchByIds.defer(newProps.value);
    }
  }

  remove(id) {
    let value = [...this.props.value].filter(v => v !== id);
    this.props.onChange(value);
  }

  add(id) {
    let value =
      this.props.value.indexOf(id) === -1
        ? [...this.props.value, id]
        : this.props.value;
    this.props.onChange(value);
  }

  shiftPosition(idx, direction) {
    let value = [...this.props.value];
    console.log(value);
    value.splice(idx + direction, 0, value.splice(idx, 1)[0]);
    console.log(value);
    this.props.onChange(value);
  }

  getStyles() {
    return {
      container: {
        margin: -10,
        display: "flex"
      },
      item: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid #ccc",
        borderRadius: "0.5em",
        padding: 20,
        margin: 10,
        width: 200,
        maxWidth: "100%",
        textAlign: "center"
      }
    };
  }

  render() {
    const styles = this.getStyles();
    const entries = this.props.value
      ? this.props.value.map(id =>
          VirtualContentStore.getVirtualContentById(id)
        )
      : [];

    return (
      <div
        style={Object.assign(
          {},
          styles.container,
          !this.state.isAdding && entries.length === 0 && { margin: -10 },
          this.props.style
        )}
      >
        {this.state.showPreviewForVirtualContent ? (
          <VirtualContentPreviewOverlay
            virtualContentId={this.state.showPreviewForVirtualContent}
            onRequestClose={() => {
              this.setState({ showPreviewForVirtualContent: null });
            }}
          />
        ) : null}
        {entries.map((virtualContent, i) => {
          if (!virtualContent) {
            return (
              <div key={this.props.value[i]} style={styles.item}>
                <WorkingIndicator />
              </div>
            );
          }
          return (
            <OrderablePanel
              key={virtualContent.id}
              keyval={i}
              style={styles.item}
              onDelete={() => this.remove(virtualContent.id)}
              onShiftPosition={this.shiftPosition}
              canShiftUp={i > 0}
              canShiftDown={i < entries.length - 1}
              direction="horizontal"
            >
              <div
                style={{ textAlign: "center", marginBottom: 5, maxWidth: 200 }}
              >
                <div style={{ wordBreak: "break-word" }}>
                  {virtualContent.label || "Unlabeled content"}{" "}
                </div>
                {virtualContent.type === "vod" ? (
                  <div>
                    <Status virtual_content={virtualContent} detailed />
                  </div>
                ) : null}
                <div>
                  <LinkLike
                    onTouchTap={() =>
                      this.setState({
                        showPreviewForVirtualContent: virtualContent.id
                      })
                    }
                  >
                    View preview
                  </LinkLike>
                </div>
              </div>
            </OrderablePanel>
          );
        })}
        {this.state.isAdding ? (
          <div
            key={"uploader"}
            style={Object.assign({}, styles.item, { width: 300 })}
          >
            <VirtualContentUploader
              useBeta={this.props.useBeta}
              onSuccess={({ id }) => {
                this.add(id);
                this.setState({ isAdding: false });
              }}
            />
          </div>
        ) : (
          <div
            key={"uploader"}
            style={{ ...styles.item, border: "none", padding: 0 }}
          >
            <RaisedButton
              label="Add virtual content"
              primary={true}
              onClick={() => this.setState({ isAdding: true })}
            />
          </div>
        )}
      </div>
    );
  }
}

export default connectToStores(VirtualContentEditor);



// WEBPACK FOOTER //
// ./src/app/components/partials/virtual-content-editor.jsx